import { render } from "./PaywallPlans.vue?vue&type=template&id=7cdf9226&scoped=true"
const script = {}

import "./PaywallPlans.vue?vue&type=style&index=0&id=7cdf9226&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cdf9226"]])

export default __exports__